// src/api/services/renewalResponseService.ts
import api from "../axios";

export type RenewalIntent = "renew" | "move-out" | "not-sure";
export type RenewalPreference =
  | "12-month"
  | "6-month"
  | "month-to-month"
  | "undecided";

export interface SubmitRenewalResponsePayload {
  intent: RenewalIntent;
  preference?: RenewalPreference | null;
  moveOutDate?: string | null;
  hasDamage?: boolean | null;
  conditionDescription?: string | null;
  hasNotes?: boolean | null;
  notes?: string | null;
  contactName?: string | null;
  contactEmail?: string | null;
  contactPhone?: string | null;
  /** Upload UUIDs already PUT to S3. */
  documentUuids?: string[];
  /** Renew path — becomes the tenant's default payment method. */
  paymentMethodId?: number | null;
}

export interface RenewalResponseDocumentDto {
  uuid: string;
  uploadUuid: string;
  fileName: string | null;
  type: string;
  createdAt: string;
}

export interface RenewalResponseDto {
  uuid: string;
  version: number;
  intent: RenewalIntent;
  preference: RenewalPreference | null;
  moveOutDate: string | null;
  hasDamage: boolean | null;
  conditionDescription: string | null;
  hasNotes: boolean | null;
  notes: string | null;
  contactName: string | null;
  contactEmail: string | null;
  contactPhone: string | null;
  submittedAt: string;
  documents: RenewalResponseDocumentDto[];
}

/** Each call is stored as a new version — earlier answers are kept. */
export function submitRenewalResponse(
  termUuid: string,
  payload: SubmitRenewalResponsePayload,
) {
  return api.post<RenewalResponseDto>(
    `/renewals/${encodeURIComponent(termUuid)}/response`,
    payload,
  );
}

export function getRenewalResponses(termUuid: string) {
  return api.get<RenewalResponseDto[]>(
    `/renewals/${encodeURIComponent(termUuid)}/response`,
  );
}
